import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { connect } from 'react-redux';
import GraficoErroGeral from './graficoErroGeral';
import { getErrosList } from './erroGeralActions';
import { Panel } from 'react-bootstrap';
import configLocal from '../configuracao/configLocal';
import ProcessingOverlay from '../common/components/processingOverlay';

moment.locale('pt-br');

const dateInputStyle = {
  width: '160px',
  height: '38px',
  padding: '7px 10px',
  fontSize: '13px',
  fontWeight: '500',
  border: '1px solid #bfd0e0',
  borderRadius: '10px',
  backgroundColor: '#ffffff',
  color: '#475569',
  boxShadow: 'none',
};

const labelStyle = {
  fontSize: '13px',
  color: '#475569',
  fontWeight: '600',
  margin: 0,
  paddingRight: '4px',
};

class ControladorErroGeralGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listErros: [],
      loading: false,
      dataInicial: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      dataFinal: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
    };

    this.loadGraphData = this.loadGraphData.bind(this);
    this.onChangeDataInicial = this.onChangeDataInicial.bind(this);
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this);
  }

  componentDidMount() {
    this.loadGraphData();
  }

  buildFiltro(dataInicial, dataFinal) {
    const numCont = configLocal.getConfig('numCont');
    return {
      dataInicial,
      dataFinal,
      controlador: numCont && +numCont !== 0 ? numCont : null,
    };
  }

  loadGraphData(dataInicial, dataFinal) {
    const filtro = this.buildFiltro(
      dataInicial || this.state.dataInicial,
      dataFinal || this.state.dataFinal,
    );

    this.setState({ loading: true });

    this.props.getErrosList(filtro).then(result => {
      this.setState({
        listErros: result.payload.data,
        loading: false,
      });
    });
  }

  onChangeDataInicial(event) {
    const dataInicial = event.target.value;
    this.setState({ dataInicial }, () => {
      if (dataInicial && this.state.dataFinal) {
        this.loadGraphData(dataInicial, this.state.dataFinal);
      }
    });
  }

  onChangeDataFinal(event) {
    const dataFinal = event.target.value;
    this.setState({ dataFinal }, () => {
      if (this.state.dataInicial && dataFinal) {
        this.loadGraphData(this.state.dataInicial, dataFinal);
      }
    });
  }

  render() {
    const grafico = <GraficoErroGeral listErros={this.state.listErros} />;

    return (
      <Panel bsStyle="success" className="erro-geral-graph-premium">
        <ProcessingOverlay
          show={this.state.loading}
          message={
            <>
              Carregando gráfico de notificações...
              <small>Aguarde enquanto os dados são consultados.</small>
            </>
          }
          tagline="Notificações"
        />

        <Panel.Heading className="panel_heading">
          <Panel.Title componentClass="div">
            <div className="erro-geral-graph-header">
              <div className="erro-geral-graph-title">
                <div className="erro-geral-graph-icon">
                  <i className="fa fa-chart-bar" />
                </div>
                <div>
                  <div className="erro-geral-graph-title-row">
                    <h3>Gráfico de Notificações</h3>
                    <span className="erro-geral-graph-top-badge">Top 10</span>
                  </div>
                  <p>Visualização das notificações agrupadas conforme os filtros selecionados.</p>
                </div>
              </div>
              <div className="erro-geral-graph-actions">
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label htmlFor="data_inicial_grafico" style={labelStyle}>
                    Data inicial:
                  </label>
                  <input
                    id="data_inicial_grafico"
                    name="data_inicial_grafico"
                    type="date"
                    className="form-control"
                    style={dateInputStyle}
                    value={this.state.dataInicial}
                    onChange={this.onChangeDataInicial}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label htmlFor="data_final_grafico" style={labelStyle}>
                    Data término:
                  </label>
                  <input
                    id="data_final_grafico"
                    name="data_final_grafico"
                    type="date"
                    className="form-control"
                    style={dateInputStyle}
                    value={this.state.dataFinal}
                    onChange={this.onChangeDataFinal}
                  />
                </div>
              </div>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <div className="erro-geral-graph-mobile-warning">
            <i className="fa fa-desktop" />
            <h4>Gráfico disponível em telas maiores</h4>
            <p>
              Para visualizar este gráfico com todos os dados e legendas, acesse em um tablet na horizontal ou em um
              computador.
            </p>
          </div>
          <div className="erro-geral-graph-chart-shell">{grafico}</div>
        </Panel.Body>
      </Panel>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getErrosList }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(ControladorErroGeralGraph);
